export default "__VITE_ASSET__BSD0GyZa__"